import React, { useState } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { ErrorFallback, MessageAlert, Loader, DataTableHoc } from 'smart-react';
import { AFFECTEDFILES } from '../../../constants/applicationConstants';
import { GridColumnsList } from '../Components/Filter/FilterElements';
import DataColumns from '../Components/DataColumns/DataColumns';
import { Card } from '@progress/kendo-react-layout';
import { useAuth } from '../../Core/Context/AuthContext';

import {
  ROW_LAYOUTS,
  PAGE_SIZE,
} from '../../../constants/applicationConstants';

import {
  deleteFilter,
  applyFilter,
  saveFilters,
} from '../../../Utils/Filters/filterSliderHandler';

const BaseAffectedFilesDataTable = React.lazy(
  () => import('../Components/DataTable/DataTable')
);
const AffectedFilesDataTable = DataTableHoc(BaseAffectedFilesDataTable);

/**
 * AffectedFiles main screen
 * @type {React.FC<Props>}
 * @returns {React.ReactElement} The AffectedFiles component.
 */
const AffectedFiles = () => {
  const { configData } = useAuth();
  const [loading, setLoading] = useState(false);
  const [rolloutsData, setRolloutsData] = React.useState([]);
  const dataColumnsArray = DataColumns({});
  const [alertMessage, setAlertMessage] = React.useState({
    alert: false,
    message: null,
  });
  // used to check API is ready to call
  const [isReady, setIsReady] = React.useState(false);

  /**
   * Description: Function for generating the base url
   * @return
   */
  const getBaseURL = (filePath, repo) => {
    let providerType = configData?.VERSION_CONTROL_PROVIDER_TYPE;
    let userName = configData?.VERSION_CONTROL_USERNAME;
    let defaultBranch = configData?.DEFAULT_BRANCH;
    let baseUrl = '';
    if (providerType === 'github') {
      baseUrl = `https://github.com/repoName/commits/${defaultBranch}/`;
    } else if (providerType === 'bitbucket') {
      baseUrl = `https://github.com/${userName}/repoName/commits/${defaultBranch}/`;
    }
    let bugBaseUrl = baseUrl.replace('repoName', repo.replace(/\s/g, ''));
    return bugBaseUrl + filePath;
  };
  /**
   * Description: create and return repo name from str
   * @param repoName string
   * @return string
   */
  const getRepoName = (repoName) => {
    let repo = repoName.split('|');
    return typeof repo[1] !== 'undefined' ? `${repo[0]} / ${repo[1]}` : repo[0];
  };

  return (
    <ErrorBoundary
      FallbackComponent={ErrorFallback}
      onReset={() => {
        // reset the state of your app so the error doesn't happen again
      }}
    >
      <React.Suspense fallback={<Loader />}>
        {loading && <Loader />}
        {alertMessage?.alert && (
          <MessageAlert
            type={'danger'}
            message={alertMessage.message}
            isIcon={true}
            iconName={'error'}
          />
        )}
        <div className="container mx-auto account-form-container">
          <div className="add-test add-test-page cards-layout-page container mx-auto">
            <div className="card-detail-content">
              <Card className="seprate-card">
                <div className="card-content">
                  <AffectedFilesDataTable
                    deleteFilter={deleteFilter}
                    applyFilter={applyFilter}
                    saveFilters={saveFilters}
                    moduleName={AFFECTEDFILES}
                    dataColumns={dataColumnsArray}
                    gridColumnsList={GridColumnsList}
                    dataTableName={AFFECTEDFILES}
                    setIsReady={setIsReady}
                    isReady={isReady}
                    rowLayoutConfigName={`${AFFECTEDFILES}.DataGrid.RowLayout`}
                    pageLengthConfigName={`${AFFECTEDFILES}.DataGrid.ItemsPerPage`}
                    dataSet={rolloutsData}
                    setDataSet={setRolloutsData}
                    initialSort={{
                      field: 'rn',
                      dir: 'asc',
                    }}
                    isCardonMobileView={false}
                    total={process.env.DefaultLimit}
                    defaultRowLayout={process.env.RowLayout}
                    rowLayouts={ROW_LAYOUTS}
                    pageSizes={PAGE_SIZE}
                    dataColumnsParams={{ getBaseURL, getRepoName }}
                    setLoading={setLoading}
                  />
                </div>
              </Card>
            </div>
          </div>
        </div>
      </React.Suspense>
    </ErrorBoundary>
  );
};
export default AffectedFiles;
